import { useNavigate } from 'react-router-dom';

import type { AppRoutes } from '@consts/routes';
import { useAlert } from './useAlert';

export const useNavAssert = (condition: any, route: AppRoutes, alert?: string) => {
    const { setAlert } = useAlert();
    const navigate = useNavigate();

    if (condition) return;

    alert && setAlert(alert, 'error');
    navigate(route);
};
